import { render, staticRenderFns } from "./ContestGroupImportPreview.vue?vue&type=template&id=70fa04ae&scoped=true&"
import script from "./ContestGroupImportPreview.vue?vue&type=script&lang=js&"
export * from "./ContestGroupImportPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContestGroupImportPreview.vue?vue&type=style&index=0&id=70fa04ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa04ae",
  null
  
)

export default component.exports